import {
  reflectComponentType,
  Type,
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  ViewContainerRef,
  input,
} from '@angular/core';

import type { CustomInputComponentInterface } from '../../../client/integrations-client.types';
import { ELEMENT_MAPPING } from '../../../integrations/elements';
import type { DynamicCustomInputConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class CustomInput extends DynamicFormInput<DynamicCustomInputConfig> {}

@Component({
  selector: 'rti-custom-input',
  template: '<ng-template #container />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class CustomInputComponent {
  public readonly input = input<CustomInput>(undefined!);

  @ViewChild('container', { read: ViewContainerRef, static: true })
  private container: ViewContainerRef;

  public ngOnInit(): void {
    const componentImport = this.findComponentClass();
    if (componentImport) {
      this.createCustomComponent(componentImport);
    } else {
      console.warn(
        `No custom component for ${this.input().config.component}. Check integrations ELEMENT_MAPPING`,
      );
    }
  }

  private findComponentClass(): undefined | (() => Promise<Type<CustomInputComponentInterface>>) {
    const mapping = ELEMENT_MAPPING.find(([key]) => key === this.input().config.component);
    return mapping && mapping[1];
  }

  private async createCustomComponent(
    componentImport: () => Promise<Type<CustomInputComponentInterface>>,
  ) {
    this.container.clear();

    const componentClass = await componentImport();
    const componentRef = this.container.createComponent(componentClass);
    const componentMirror = reflectComponentType(componentClass)!;
    if (componentRef.instance.initState) {
      componentRef.instance.initState(this.input().config.componentData, this.input().control);
    } else {
      const input = this.input();
      const inputs = componentMirror.inputs.map(i => i.propName);
      Object.entries(input.config.componentData).forEach(([key, value]) => {
        if (inputs.includes(key)) {
          componentRef.setInput(key, value);
        } else {
          componentRef.instance[key] = value;
        }
      });
      componentRef.setInput('formControl', input.control);
    }
    componentRef.changeDetectorRef.detectChanges();
  }
}
